<app-card-lg [title]="'Services'">
  <div *appLoading="(loading$ | async) || (machinesLoading$ | async)"></div>
  @if (!(loading$ | async) && !(machinesLoading$ | async)) {
    @for (service of services$ | async; track service) {
      <app-services-list-item [service]="service" [machine]="getMachine(service.machine_id || '')" [machineId]="machineId"></app-services-list-item>
    }
  }
</app-card-lg>
